class EvergreenGifAnimation {
	applyNewSrcAttribute(gif: Element): void {
		const src = gif.getAttribute("src") || "";
		const loopGif = src + "?a=" + Math.random().toString();
		gif.setAttribute("src", loopGif);
	}
}

document.querySelectorAll(".envelope-gif").forEach(gif => {
	const newSrc = new EvergreenGifAnimation();
	newSrc.applyNewSrcAttribute(gif);
});
